import { openBlock, createElementBlock, createElementVNode } from "vue";
import { _ as _export_sfc } from "./index-nOmQweDK.mjs";
const _sfc_main = {};
const _hoisted_1 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M20.0289 5.97927L13.4085 2.31553C12.5488 1.84233 11.4791 1.84233 10.6188 2.31553L3.9984 5.97927C3.13805 6.45248 2.59961 7.34153 2.59961 8.2951V15.6226C2.59961 16.5762 3.13088 17.4652 3.9984 17.9384L10.6188 21.6021C11.0526 21.8387 11.5315 21.9606 12.0176 21.9606C12.5037 21.9606 12.9826 21.8387 13.4085 21.6021L20.0289 17.9384C20.8892 17.4652 21.4277 16.5762 21.4277 15.6226V8.2951C21.4277 7.34153 20.8964 6.45248 20.0289 5.97927Z",
  fill: "#FFE3CA"
}, null, -1);
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.013 1.96063C11.5305 1.96063 11.048 2.07893 10.6178 2.31553L3.99814 5.97927C3.13779 6.45248 2.59863 7.34153 2.59863 8.2951V15.6226C2.59863 16.5762 3.1299 17.4652 3.99814 17.9384L10.6178 21.6021C11.0516 21.8387 11.5305 21.9606 12.0166 21.9606C12.5027 21.9606 12.9816 21.8387 13.4082 21.6021L20.0286 17.9384C20.8882 17.4652 21.4267 16.5762 21.4267 15.6226V8.2951C21.4267 7.34153 20.8961 6.45248 20.0286 5.97927L13.4082 2.31553C12.978 2.07893 12.4955 1.96063 12.013 1.96063ZM12.013 3.03609C12.3228 3.03609 12.626 3.1128 12.887 3.2562L19.5131 6.92352C20.0301 7.20529 20.3513 7.73083 20.3513 8.29509V15.6226C20.3513 16.184 20.0293 16.7102 19.5074 16.9977L12.8863 20.6615C12.6232 20.8077 12.322 20.8852 12.0166 20.8852C11.7112 20.8852 11.4058 20.8063 11.1383 20.6615L4.51293 16.9941C3.99529 16.7124 3.67409 16.1868 3.67409 15.6226V8.29509C3.67409 7.7337 3.99672 7.20744 4.51867 6.91994L11.1362 3.25763C11.4 3.1128 11.7033 3.03609 12.013 3.03609Z",
  fill: "#FFD7B1"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.109 11.4175C13.0712 11.4175 13.5616 11.2232 13.5616 10.3335C13.5616 9.56845 13.0712 9.21355 12.3162 9.21355H11.2716V11.4175H12.109ZM9.41016 15.5753V8.96834C9.41016 8.0585 9.75143 7.69643 10.6204 7.69643H12.5856C14.2604 7.69643 15.3258 8.72027 15.3258 10.2919C15.3258 11.9674 14.2503 12.9088 12.4924 12.9088H11.2613V15.5652C11.2613 16.1962 10.9201 16.5683 10.3307 16.5683C9.74139 16.5683 9.41016 16.2062 9.41016 15.5753Z",
  fill: "#FC6020"
}, null, -1);
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click", $event))
  }, _hoisted_4);
}
const icV2StovePointColor = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  icV2StovePointColor as default
};
